import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    profile: null,
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setProfileInfo: (state, action) => {
            state.profile = action.payload;
        },
        clearProfileInfo: (state) => {
            state.profile = null;
        },
    },
});

export const { setProfileInfo, clearProfileInfo } = profileSlice.actions;
export default profileSlice.reducer;